var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"side",on:{"click":_vm.sideClick}},[_c('img',{attrs:{"src":require("@/assets/img/AI.gif"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }